module.exports = __webpack_public_path__ + "img/page-box-3.8c0c043.jpg";